import base from './base.js'
import token from './token.js'

import user from './user/user'
import userPendWarning from './user/pendWarning'
import userWarningList from './user/warningList'
import userNoticeRule from './user/noticeRule'
import userNoticeList from './user/noticeList'
import userProcessWorkList from './user/processWorkList'
import userCloseWorkList from './user/closeWorkList'
import userComprehensiveInspection from './user/comprehensiveInspection'
import userAwrUnscramble from './user/awrUnscramble'
import userNewWorkList from './user/newWorkList'
import userEditorWorkList from './user/editWorkList'

import admin from './admin/admin'
import adminPendWarning from './admin/pendWarning'
import adminSiteManaging from './admin/siteManaging'
import adminPersonManaging from './admin/personManaging'
import adminServerAuthorization from './admin/serverAuthorization'
import adminProcessWorkList from './admin/processWorkList'
import adminDealingWorkList from './admin/dealingWorkList'
import adminCloseWorkList from './admin/closeWorkList'
import adminNoticeRule from './admin/noticeRule'
import adminAssignWorkList from './admin/assignWorkList'

import bigScreenMap from './admin/bigScreenMap'

import oneKeeperPartner from './onekeeper/partner'

const install = (Vue) => {
    Vue.prototype.$api = {
        isMock: false,
        get: base.get,
        post: base.post,
        put: base.put,
        patch: base.patch,
        delete: base.delete,
        getFile: base.getFile,
        postFile: base.postFile,
        putFile: base.putFile,
        file: base.file,
        handleRequest: base.handleRequest,
        token,
        user,
        userPendWarning,
        userWarningList,
        userNoticeRule,
        userNoticeList,
        userProcessWorkList,
        userCloseWorkList,
        userComprehensiveInspection,
        userAwrUnscramble,
        userNewWorkList,
        userEditorWorkList,
        admin,
        adminPendWarning,
        adminSiteManaging,
        adminPersonManaging,
        adminServerAuthorization,
        adminProcessWorkList,
        adminDealingWorkList,
        adminCloseWorkList,
        adminNoticeRule,
        adminAssignWorkList,
        bigScreenMap,
        oneKeeperPartner
    }
}

export default {
    install
}